import { Animated } from 'react-native';

export const getTimingAnimation = (value: Animated.Value, toValue: number, duration: number, useNativeDriver: boolean) => {
	return Animated.timing(value, {
		toValue,
		duration,
		useNativeDriver
	});
};
